var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewFile',{attrs:{"wpsUrl":_vm.jwpsUrl,"token":_vm.jtoken}})
}
var staticRenderFns = []

export { render, staticRenderFns }